import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { TRADE_IN_VALUE } from 'site-modules/shared/constants/appraisal/appraisal';
import { AppraisalReportStepHead } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/appraisal-report-step/appraisal-report-step-head';
import { AppraisalReportStepDescription } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/appraisal-report-step/appraisal-report-step-description';
import { AppraisalReportStepPrices } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/appraisal-report-step/appraisal-report-step-prices';

export function AppraisalReport({
  getVehicleData,
  onPayoffChange,
  onPaymentLimitsLoading,
  changeStep,
  vehiclePhoto = '',
  totalPrices = {},
  // optional below
  priceList = [],
  sellingPrice = 0,
  msrp = 0,
  residualValue = 0,
  isPurchase = false,
  isUsed = false,
  color = {},
  condition = '',
  mileage = '',
  showExteriorColor = false,
  showAddEquipment = false,
  zipCode = '',
  displayTradeInValues = true,
}) {
  const { makeName, modelName, makeSlug, modelSlug, styleName, year, styleId } = getVehicleData();
  const title = `${year} ${makeName} ${modelName}`;
  const totalPriceTradeInValue = totalPrices[TRADE_IN_VALUE];
  const descriptionValues = [
    { title: 'Appraisal value:', value: totalPriceTradeInValue, isTotal: true },
    { title: 'Mileage', value: mileage },
    { title: 'Exterior', value: color.name },
    { title: 'Condition', value: condition },
  ];

  return (
    <Row className="mb-md-1_5 appraisal-report-step-head">
      <AppraisalReportStepHead
        changeStep={changeStep}
        title={title}
        make={makeSlug}
        model={modelSlug}
        style={styleName}
        photo={vehiclePhoto}
        descriptionValues={descriptionValues}
        showExteriorColor={showExteriorColor}
        showAddEquipment={showAddEquipment}
      />
      <Col xs={12} md={6} className="pt-md-0_5">
        <AppraisalReportStepDescription descriptionValues={descriptionValues} />
        <AppraisalReportStepPrices
          totalPrice={totalPriceTradeInValue}
          priceList={priceList}
          onPayoffChange={onPayoffChange}
          onPaymentLimitsLoading={onPaymentLimitsLoading}
          sellingPrice={sellingPrice}
          msrp={msrp}
          residualValue={residualValue}
          isPurchase={isPurchase}
          isUsed={isUsed}
          styleId={styleId}
          zipCode={zipCode}
          displayTradeInValues={displayTradeInValues}
        />
      </Col>
    </Row>
  );
}

AppraisalReport.propTypes = {
  getVehicleData: PropTypes.func.isRequired,
  changeStep: PropTypes.func.isRequired,
  onPayoffChange: PropTypes.func.isRequired,
  onPaymentLimitsLoading: PropTypes.func.isRequired,
  priceList: PropTypes.arrayOf(PropTypes.shape({})),
  totalPrices: PropTypes.shape({}),
  sellingPrice: PropTypes.number,
  msrp: PropTypes.number,
  residualValue: PropTypes.number,
  isPurchase: PropTypes.bool,
  isUsed: PropTypes.bool,
  vehiclePhoto: PropTypes.string,
  color: PropTypes.shape({}),
  condition: PropTypes.string,
  mileage: PropTypes.string,
  showExteriorColor: PropTypes.bool,
  showAddEquipment: PropTypes.bool,
  zipCode: PropTypes.string,
  displayTradeInValues: PropTypes.bool,
};
